import { render, staticRenderFns } from "./AnnualObjective.vue?vue&type=template&id=2287b7ca&scoped=true"
import script from "./AnnualObjective.vue?vue&type=script&lang=js"
export * from "./AnnualObjective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2287b7ca",
  null
  
)

export default component.exports